// Entry point.
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { createAdminClient } from "./api/client";
import { createOpsDeviceClient } from "./api/ops";
import { createFirebaseAuth } from "./auth/auth";
import { ServicesContext } from "./components/context";
import { loadConfig } from "./config";
import "./fonts/fonts.css";
import "./styles.css";

const config = loadConfig();
const auth = createFirebaseAuth(config);
const api = createAdminClient({ baseUrl: config.apiBaseUrl, getIdToken: () => auth.getIdToken() });
const ops = createOpsDeviceClient({ baseUrl: config.apiBaseUrl, getIdToken: () => auth.getIdToken() });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ServicesContext.Provider value={{ api, auth, config, ops }}>
      <App />
    </ServicesContext.Provider>
  </StrictMode>,
);
